import { render, staticRenderFns } from "./ClienteFornecedor.vue?vue&type=template&id=5f19b924&"
import script from "./ClienteFornecedor.vue?vue&type=script&lang=js&"
export * from "./ClienteFornecedor.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./ClienteFornecedor.vue?vue&type=style&index=1&id=5f19b924&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports